import React, { useState } from "react";
import i18n from "../lib/i18n";
import { number, string, oneOfType, func } from "prop-types";
import AttachmentListContainer from "./AttachmentListContainer";
import AttachmentDropzone from "./AttachmentDropzone";

const AttachmentView = ({
  maxUploadSizeMB,
  resourceId,
  resourceType,
  resourcePath,
  allowedExtensions = "",
  simpleList = false,
  isClone = false,
  context,
  onChange,
}) => {
  const [counter, setCounter] = useState(0);
  const [notice, setNotice] = useState(null);
  const showDropzone = !isClone;

  return (
    <>
      {notice && (
        <div className={`alert alert-${notice.alertType}`} role="alert">
          <div className="alert-content">
            <ul>
              {notice.messages.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {showDropzone && (
        <AttachmentDropzone
          maxSize={maxUploadSizeMB}
          resourceType={resourceType}
          resourceId={resourceId}
          onUploadComplete={() => {
            setCounter(counter + 1);
            onChange?.();
          }}
          allowedExtensions={allowedExtensions}
          context={context}
        />
      )}

      <AttachmentListContainer
        simpleList={simpleList}
        isClone={isClone}
        key={counter}
        parentId={resourceId}
        resourcePath={resourcePath}
        context={context}
        onDelete={() => {
          setNotice({
            alertType: "success",
            messages: [i18n.t("js.components.attachment_view.removed_file")],
          });
          onChange?.();
        }}
      />
    </>
  );
};

export default AttachmentView;

AttachmentView.propTypes = {
  maxUploadSizeMB: number.isRequired,
  resourceId: oneOfType([string, number]).isRequired,
  resourceType: string.isRequired,
  resourcePath: string.isRequired,
  allowedExtensions: string,
  context: string,
  onChange: func,
};
